import { SideMenu as Component } from './components/SideMenu';
import Connector from './connector';

export const SideMenu = () => <Connector component={Component} />;
